import { Link, Typography } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const CustomLink = ({
  onClick,
  size,
  title,
  fontSize,
  disabled,
  textColor,
  href,
}) => {
  const { bt } = useBizTypeTranslation();

  return (
    <Link
      href={href}
      target={href ? "_blank" : null}
      size={size ? size : "small"}
      onClick={onClick && !disabled ? onClick : () => { }}
    >
      <Typography
        fontSize={fontSize ?? 16}
        noWrap
        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer", }}
        color={disabled ? "#bcbcbc" : textColor ? textColor : "primary.main"}
      >
        {bt(title)}
      </Typography>
    </Link>
  );
};
export default CustomLink;
